import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { FormlyFieldProps } from '../form-field/form-field.wrapper';
import { FormlyFieldSelect } from './formly-select-component';

interface SelectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  appendTo?: any;
  filterable?: boolean;
  showToggleAll?: boolean;
}

export interface FormlyMultiSelectFieldConfig
  extends FormlyFieldConfig<SelectProps> {
  type: 'select' | Type<FormlyFieldSelect>;
}

@Component({
  selector: 'formly-field-primeng-select',
  template: `
    <p-multiselect
      [placeholder]="props.placeholder"
      [options]="(props.options | formlySelectOptions: field | async) ?? []"
      [formControl]="formControl"
      styleClass="field-select-panel"
      [formlyAttributes]="field"
      [showClear]="!props.required"
      [appendTo]="props.appendTo"
      [filter]="props.filterable"
      [showToggleAll]="props.showToggleAll"
      display="chip"
      (onChange)="props.change && props.change(field, $event)"
    >
    </p-multiselect>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyMultiSelectFieldComponent extends FieldType<
  FieldTypeConfig<SelectProps>
> {}
